import api from "./base-api"

const spammerApi = api.injectEndpoints({
    endpoints: (build) => ({
        existsSpammer: build.query({
            query: ({ project, userId = "" }) => `v1/${project}/spammers/${userId}`,
            providesTags: (_, __, { project }) => [`${project}-spammer`]
        }),
        createSpammer: build.mutation({
            query: ({ project, userId = "" }) => ({
                url: `v1/${project}/spammers/${userId}`,
                method: "POST"
            }),
            invalidatesTags: (_, __, { project }) => [`${project}-spammer`]
        }),
        deleteSpammer: build.mutation({
            query: ({ project, userId = "" }) => ({
                url: `v1/${project}/spammers/${userId}`,
                method: "DELETE"
            }),
            invalidatesTags: (_, __, { project }) => [`${project}-spammer`]
        })
    }),
    overrideExisting: false
})

export const {
    useExistsSpammerQuery,
    useCreateSpammerMutation,
    useDeleteSpammerMutation
} = spammerApi
